// extracted by mini-css-extract-plugin
export default {"img":"SponsorsSection_img__3X6eb"};